import type { MarketType } from './types'

export const DEFAULT_QUOTE = 'USDT'

export const buildSymbol = (asset: string, quote: string, marketType: MarketType) => {
  const a = asset.toUpperCase()
  const q = quote.toUpperCase()
  return marketType === 'spot' ? `${a}/${q}` : `${a}/${q}:${q}`
}
